import { EoWriter, Item, PacketAction, PacketFamily } from 'eolib';
import type { Client } from '@/client';

export type RoomItem = {id:number;name:string;amount:string|number};
export type RoomEquipment = {id:number;item_id:number;name:string;upgrade:number};
export type RoomSnapshot = {map_id:number;room_type:string;gold?:string;items?:RoomItem[];instances?:RoomEquipment[];
  inventory:RoomItem[];equipment:RoomEquipment[];error?:string|null;house_keys?:number[];house_price?:number;inside?:boolean;key_item_id?:number;key_selection?:boolean;open_vault?:boolean;
  house_invitations?:{key:number;host_name:string;expires:number}[];
  house_offer?:{operation:string;key:number;price:number;seller:string};
  house_design?:{key:number;guild?:boolean;revision:number;width:number;height:number;protected:{x:number;y:number}[];
    catalogue:{layer:number;graphic:number}[];design:{cell:{x:number;y:number;layer:number};graphic:number}[];
    quote?:{operation:string;cost:number}|null}|null};
type Store={snapshot?:RoomSnapshot;pending:boolean;listeners:Set<()=>void>;timer?:number};
const stores=new WeakMap<Client,Store>();
function store(client:Client):Store{let value=stores.get(client);if(!value){value={pending:false,listeners:new Set()};stores.set(client,value);}return value;}
export function getPrivateRoom(client:Client){const value=store(client);return {...value,snapshot:value.snapshot?.map_id===client.mapId?value.snapshot:undefined};}
export function subscribePrivateRoom(client:Client,listener:()=>void){store(client).listeners.add(listener);return ()=>{store(client).listeners.delete(listener);};}
export function clearPrivateRoom(client:Client){const state=store(client);clearTimeout(state.timer);state.pending=false;state.snapshot=undefined;for(const notify of state.listeners)notify();}
export function receivePrivateRoom(client:Client,data:unknown){
  if(!data||typeof data!=='object')return;
  const value=data as RoomSnapshot;
  if(value.map_id!==client.mapId||!Array.isArray(value.inventory)||!Array.isArray(value.equipment))return;
  if(value.inventory.every(i=>Number.isInteger(i.id)&&i.id>0&&typeof i.amount==='number'&&Number.isSafeInteger(i.amount)&&i.amount>0)){
    client.inventoryController.items=value.inventory.map(i=>{const item=new Item();item.id=i.id;item.amount=Number(i.amount);return item;});
    client.inventoryController.refreshEnhancementDisplay();
  }
  const state=store(client);clearTimeout(state.timer);state.snapshot=value;state.pending=false;for(const notify of state.listeners)notify();
  if(value.open_vault)client.keyboardController.notifyToggleDialog('privateRoom');
  if(value.key_selection&&value.house_keys?.length){
    const keys=value.house_keys;
    client.alertController.showInput('Choose your house key',`Each key opens a different home. Enter the house number from your keys: ${keys.map(key=>`#${key}`).join(', ')}.`,input=>{
      const key=Number(input?.trim().replace(/^#/,''));
      if(Number.isSafeInteger(key)&&keys.includes(key))sendRoomAction(client,'house_enter',String(key));
    });
  }
}
export function sendRoomAction(client:Client,action:string,node=''){
  const state=store(client);
  // A Home refresh must not silently swallow entry or the ability to leave.
  if(state.pending&&!['guild_room','room_leave','house_enter','house_visit'].includes(action))return false;
  if(node.length>(action==='house_quote'?7000:64))return false;
  const writer=new EoWriter();writer.addString(JSON.stringify({action,node}));
  client.bus.sendBuf(58 as PacketFamily,PacketAction.Request,writer.toByteArray());
  if(!['guild_room','room_leave','house_enter','house_visit'].includes(action)){
    state.pending=true;clearTimeout(state.timer);state.timer=window.setTimeout(()=>{
      state.pending=false;state.snapshot=undefined;for(const notify of state.listeners)notify();
    },8000);
    for(const notify of state.listeners)notify();
  }
  return true;
}
